import { epodActions } from './epodActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  epodData: [],
  imageUrl: null,
  error: null,
  otpVerified: false,
  responseOtp: null
};

const epodReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case epodActions.EPOD_VERIFY_OTP: {
      return Object.assign({}, state, action.payload);
    }
    case epodActions.EPOD_GET_FORM: {
      return Object.assign({}, state, action.payload);
    }
    case epodActions.EPOD_POST_IMAGE: {
      return Object.assign({}, state, action.payload);
    }
    case epodActions.EPOD_POST_FORM: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default epodReducer;
